var render = function render(){var _vm=this,_c=_vm._self._c;return _c('basic-page',{attrs:{"fluid":"","title":"Tehtävät"}},[_c('v-row',{staticClass:"fill-height tehtavat"},[_c('v-col',{staticClass:"mt-n5",attrs:{"cols":"12","lg":"12","offset-xl":"2","xl":"8"}},[_c('tehtavat-hallitus',{attrs:{"from":"general"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }